import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import {
  CreditOnDeletion,
  formatCents,
  hasCredit,
} from '../../../services/users-management/what-the-deletion-does-with-the-credit';

@Component({
  selector: 'bo-delete-user-confirm-dialog',
  imports: [TranslateModule, CommonModule, FormsModule, DialogModule],
  templateUrl: './delete-user-confirm-dialog.component.html',
  styleUrl: './delete-user-confirm-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteUserConfirmDialogComponent {
  @Input() visible = false;
  @Input() userName = '';
  @Input() confirmed = false;
  @Input() deleting = false;
  /** What the deletion does with the member's credit. Null when the API did not say. */
  @Input() credit: CreditOnDeletion | null = null;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() confirmedChange = new EventEmitter<boolean>();
  @Output() cancelled = new EventEmitter<void>();
  @Output() deleteConfirmed = new EventEmitter<void>();

  get hasCredit(): boolean {
    return hasCredit(this.credit);
  }

  /** French formatting, like every other amount in the back office (format.util.ts). */
  amount(cents: number): string {
    return formatCents(cents, this.credit?.currency ?? 'EUR', 'fr-FR');
  }

  onVisibleChange(visible: boolean) {
    if (!visible) {
      this.cancelled.emit();
    }
    this.visibleChange.emit(visible);
  }

  onConfirmedChange(value: boolean) {
    this.confirmedChange.emit(value);
  }

  onCancel() {
    this.cancelled.emit();
    this.visibleChange.emit(false);
  }

  onConfirm() {
    this.deleteConfirmed.emit();
  }
}
